import "./SessioFinal.css";
import SessioFinalImage from "../../individual/SessioFinalImage/SessioFinalImage";
import aliciaRomero from "../../../assets/ponents/Alicia Romero.png";
import collboni from "../../../assets/ponents/Jaume Collboni.jpg";
import carlesTrevy from "../../../assets/ponents/Travy.png";
import nataliaMas from "../../../assets/ponents/Natalia Mas.png";
import jaumeGiro from "../../../assets/ponents/Jaume Giró.jpg";
import pereAragones from "../../../assets/ponents/Pere Aragonès.jpg";
import junqueras from "../../../assets/ponents/Oriol Junqueras.jpg";
import castells from "../../../assets/ponents/Antoni Castells.jpg";
import angelsFito from "../../../assets/ponents/Angels Fito.jpg";
import xavierFerras from "../../../assets/ponents/XAVIER FERRAS.jpg";
import annaGarriga from "../../../assets/ponents/Anna Garriga.png";
import teresaMonllau from "../../../assets/ponents/Teresa Monllau.jpg";
import adaFerrer from "../../../assets/ponents/Ada Ferrer.png";
import josepOliver from "../../../assets/ponents/Josep Oliver.jpg";
import miquelPuig from "../../../assets/ponents/Miquel Puig Rasposo.jpg";
import joanTugores from "../../../assets/ponents/Joan Tugores.jpg";
import elisabetAlier from "../../../assets/ponents/elisabet alier.jpg";
import alfonsoAlvarez from "../../../assets/ponents/Alfonso Alvarez.png";
import auroraCata from "../../../assets/ponents/AURORA CATÁ.jpg";
import carmeHortala from "../../../assets/ponents/Carme Hortola.png";
import josepMartinez from "../../../assets/ponents/Josep Martínez Vila.jpg";
import oriolSegarra from "../../../assets/ponents/Oriol Segarra.png";
import oriolAmat from "../../../assets/ponents/Oriol Amat 05.png";
import josepRull from "../../../assets/ponents/josep rull.jpg";
import jordiHereu from "../../../assets/ponents/jordi hereu.jpg";
import salvadorIlla from "../../../assets/ponents/Salvador Illa.png";
import martiParellada from "../../../assets/ponents/Martí_Parellada.jpg";

const SessioFinal = () => {
  return (
    <div className="sessio-final">
      <div className="sessio-final__header">
        <h2 className="sessio-final__day-title">DIA</h2>
        <div className="sessio-final__day-box">
          <div className="sessio-final__day-number">20</div>
        </div>
        <p className="sessio-final__date">Divendres 20 de juny</p>
      </div>

      <div className="sessio-final__content">
        <div className="sessio-final__block">
          <p className="sessio-final__time">8:45 hores</p>
          <h3 className="sessio-final__title">INAUGURACIÓ</h3>
          <div className="sessio-final__wrapper">
            <SessioFinalImage
              sessioFinalImage={aliciaRomero}
              name="Alícia Romero Llano"
              years="Consellera d'Economia i Finances"
            />
            <SessioFinalImage
              sessioFinalImage={collboni}
              name="Jaume Collboni Cuadrado"
              years="Alcalde de Barcelona"
            />
            <SessioFinalImage
              sessioFinalImage={carlesTrevy}
              name="Carles Puig de Travy"
              years="Degà del Col·legi d'Economistes de Catalunya"
            />
          </div>
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">9:15 hores</p>
          <h3 className="sessio-final__title">
            TAULA RODONA: LA VISIÓ DELS EX CONSELLERS D'ECONOMIA DE LA
            GENERALITAT
          </h3>
          <div className="sessio-final__wrapper">
            <SessioFinalImage
              sessioFinalImage={nataliaMas}
              name="Natàlia Mas Guix"
              years="Consellera d'Economia i Hisenda 2022-2024"
            />
            <SessioFinalImage
              sessioFinalImage={jaumeGiro}
              name="Jaume Giró Ribas"
              years="Conseller d'Economia i Hisenda 2021-2022"
            />
            <SessioFinalImage
              sessioFinalImage={pereAragones}
              name="Pere Aragonès Garcia"
              years="Conseller d'Economia i Hisenda 2018-2020"
            />
            <SessioFinalImage
              sessioFinalImage={junqueras}
              name="Oriol Junqueras Vies"
              years="Conseller d'Economia i Hisenda 2016-2017"
            />
            <SessioFinalImage
              sessioFinalImage={castells}
              name=" Antoni Castells Oliveres"
              years="Conseller d'Economia i Hisenda 2003-2010"
            />
          </div>
          <p className="sessio-final__moderator">
            Modera: Àngels Fitó Bertran, vicedegana del Col·legi d'Economistes
            de Catalunya i rectora de la UOC
          </p>
          <SessioFinalImage
            sessioFinalImage={angelsFito}
            name=" Àngels Fitó Bertran"
            years="Vicedegana del Col·legi d'Economistes
            de Catalunya i rectora de la UOC"
          />
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">10:05 hores</p>
          <h3 className="sessio-final__title">
            TAULA RODONA: ECONOMIA, PRESENT I FUTUR
          </h3>
          <div className="sessio-final__wrapper">
            <SessioFinalImage
              sessioFinalImage={xavierFerras}
              name="Xavier Ferràs Hernàndez"
              years="Full Professor a ESADE"
            />
            <SessioFinalImage
              sessioFinalImage={annaGarriga}
              name="Anna Garriga Ripoll"
              years="Professora d'Economia de la UdG"
            />
            <SessioFinalImage
              sessioFinalImage={teresaMonllau}
              name="Teresa Monllau Jaques"
              years="Degana de la Facultat d'Economia i Empresa de la UPF"
            />
            <SessioFinalImage
              sessioFinalImage={josepOliver}
              name="Josep Oliver Alonso"
              years="Catedràtic emèrit d'Economia Aplicada de la UAB"
            />
            <SessioFinalImage
              sessioFinalImage={miquelPuig}
              name="Miquel Puig Raposo"
              years="Doctor en Economia"
            />
            <SessioFinalImage
              sessioFinalImage={joanTugores}
              name="Joan Tugores Ques"
              years="Catedràtic emèrit d'Economia de la UB"
            />
          </div>
          <p className="sessio-final__moderator">
            Modera: Ada Ferrer Carbonell, presidenta de la Societat Catalana
            d'Economia
          </p>
          <SessioFinalImage
            sessioFinalImage={adaFerrer}
            name="Ada Ferrer Carbonell"
            years="Presidenta de la Societat Catalana d'Economia"
          />
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">10:55 hores</p>
          <h3 className="sessio-final__title">PAUSA CAFÈ</h3>
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">11:40 hores</p>
          <h3 className="sessio-final__title">
            TAULA RODONA: CONTRIBUCIÓ DEL TEIXIT EMPRESARIAL
          </h3>
          <div className="sessio-final__wrapper">
            <SessioFinalImage
              sessioFinalImage={elisabetAlier}
              name="Elisabet Alier Benages"
              years="Presidenta d'Alier"
            />
            <SessioFinalImage
              sessioFinalImage={alfonsoAlvarez}
              name="Alfonso Álvarez Villamarin"
              years="CEO de Cellnex España"
            />
            <SessioFinalImage
              sessioFinalImage={auroraCata}
              name="Aurora Catà Sala"
              years="Consellera independent de Repsol i del Banc Sabadell"
            />
            <SessioFinalImage
              sessioFinalImage={carmeHortala}
              name="Carme Hortalà Vallvé"
              years="Directora de GVC Gaesco"
            />
            <SessioFinalImage
              sessioFinalImage={josepMartinez}
              name="Josep Martínez Vila"
              years="Conseller delegat de Saba Infraestructures"
            />
            <SessioFinalImage
              sessioFinalImage={oriolSegarra}
              name="Oriol Segarra Montaner"
              years="Conseller delegat d'Uriach"
            />
          </div>
          <p className="sessio-final__moderator">
            Modera: Oriol Amat Salas, president del Comitè Organitzador del IV
            Congrés d'Economia i Empresa de Catalunya i membre de la Junta de
            Govern del Col·legi d'Economistes de Catalunya
          </p>
          <SessioFinalImage
            sessioFinalImage={oriolAmat}
            name="Oriol Amat Salas"
            years="President del Comitè Organitzador del IV Congrés i membre de la Junta del Col·legi"
          />
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">12:30 hores</p>
          <h3 className="sessio-final__title">CONCLUSIONS</h3>
          <SessioFinalImage
            sessioFinalImage={martiParellada}
            name={"Martí Parellada Sabata"}
            years={
              "President del Comitè Científic del IV Congrés d'Economia i Empresa de Catalunya"
            }
          />
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">12:45 hores</p>
          <h3 className="sessio-final__title">LLIURAMENT DE PREMIS</h3>
          <p>A les millors ponències i comunicacions</p>
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">13:05 hores</p>
          <h3 className="sessio-final__title">CLOENDA</h3>
          <div className="sessio-final__wrapper">
            <SessioFinalImage
              sessioFinalImage={josepRull}
              name="Josep Rull Andreu"
              years="President del Parlament de Catalunya"
            />
            <SessioFinalImage
              sessioFinalImage={jordiHereu}
              name="Jordi Hereu Boher"
              years="Ministre d'Indústria i Turisme del govern d'Espanya"
            />
            <SessioFinalImage
              sessioFinalImage={salvadorIlla}
              name="Salvador Illa Roca"
              years="President de la Generalitat de Catalunya"
            />
            <SessioFinalImage
              sessioFinalImage={carlesTrevy}
              name="Carles Puig de Travy"
              years="Degà del Col·legi d'Economistes de Catalunya"
            />
          </div>
        </div>

        <div className="sessio-final__block">
          <p className="sessio-final__time">14:00 hores</p>
          <h3 className="sessio-final__title">DINAR NETWORKING</h3>
        </div>
      </div>
      <div className="sessio-final__cta">
        <a
          href="https://forms.office.com/pages/responsepage.aspx?id=ZpJqopPMo0q-aUCpDC5YwSAPgg5x2-lLmpU62wO99N1UQVlHMktZRUk1MUZWMVdDNU9DVUZORVFKRy4u&route=shorturl"
          className="sessio-final__button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Inscriu-t'hi aquí
        </a>
      </div>
    </div>
  );
};

export default SessioFinal;
